import "./LandingPage.css";

const JLPT_TOOL_HREF = "./jlpt.html";
const MOODLE_TOOL_HREF = "./moodle.html";

export default function LandingPage() {
  return (
    <div className="landing">
      <header className="landing-header">
        <p className="landing-kicker">JLPT Questions Generator</p>
        <h1 className="landing-title">問題バンク変換ツール</h1>
        <p className="landing-lead">用途に合わせてツールを選択してください。</p>
      </header>

      <div className="tool-grid">
        <article className="tool-card">
          <div className="tool-card-badge">Tool 1</div>
          <h2 className="tool-card-title">JLPT Excel → LearnWorlds</h2>
          <p className="tool-card-desc">
            JLPT問題ExcelをLearnWorldsインポート用フォーマットに変換します。グループ設定・カテゴリ・指示文の編集に対応。
          </p>
          <ul className="tool-card-features">
            <li>Excelアップロード</li>
            <li>グループ別メタデータ設定</li>
            <li>LearnWorlds .xlsx 出力</li>
          </ul>
          <a className="tool-card-btn" href={JLPT_TOOL_HREF}>
            このツールを開く
          </a>
        </article>

        <article className="tool-card tool-card--accent">
          <div className="tool-card-badge">Tool 2</div>
          <h2 className="tool-card-title">LearnWorlds → Moodle XML</h2>
          <p className="tool-card-desc">
            LearnWorlds形式の問題バンクExcelをMoodle XML形式に変換します。多言語フィードバック翻訳に対応。
          </p>
          <ul className="tool-card-features">
            <li>TMC / TMCMA / TTF / TST 対応</li>
            <li>General feedback 多言語翻訳</li>
            <li>Moodle XML ダウンロード</li>
          </ul>
          <a className="tool-card-btn" href={MOODLE_TOOL_HREF}>
            このツールを開く
          </a>
        </article>
      </div>

      <footer className="landing-footer">
        内部利用向けツール — ブラウザ内で処理されます（APIキーはサーバー側のみ）
      </footer>
    </div>
  );
}
